import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'RAI Italia',
    callsign: 'RAIITA',
    logoUrl: 'https://imgx.fubo.tv/station_logos/rai_italia_c.png',
    slug: 'rai-italia',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="RAIITA"
        title="Watch RAI Italia live online with Fubo"
        networkName="RAI Italia"
      />
    </>
  )
}
